<template>
  <div class="contact-page">
    <div class="contact-header">
      <h1>{{ t('contactTitle') }}</h1>
      <p>{{ t('contactDesc') }}</p>
    </div>
    
    <div class="contact-container">
      <div class="contact-info">
        <div class="contact-item">
          <div class="contact-icon phone-icon">📞</div>
          <div class="contact-details">
            <h3>{{ t('phone') }}</h3>
            <p>{{ t('phone1') }}</p>
          </div>
        </div>
        
        <div class="contact-item">
          <div class="contact-icon wechat-icon">💬</div>
          <div class="contact-details">
            <h3>{{ t('whatsappWechat') }}</h3>
            <p>{{ t('phone2') }}</p>
          </div>
        </div>
        
        <div class="contact-item">
          <div class="contact-icon email-icon">📧</div>
          <div class="contact-details">
            <h3>{{ t('emailLabel') }}</h3>
            <p>{{ t('email') }}</p>
          </div>
        </div>
        
        <div class="contact-item">
          <div class="contact-icon address-icon">📍</div>
          <div class="contact-details">
            <h3>{{ t('addressLabel') }}</h3>
            <p>{{ t('address') }}</p>
          </div>
        </div>
      </div>
      
      <div class="contact-map">
        <!-- 谷歌地图嵌入式iframe -->
        <iframe width="100%" height="100%" frameborder="0" loading="lazy" allowfullscreen="" aria-hidden="false" tabindex="0"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3691.0847162179427!2d114.23822611526445!3d22.311846648358146!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x340400634d6b136f%3A0xc80992f7c9449a12!2sDR%20MOTOR%20LTD!5e0!3m2!1szh-CN!2shk!4v1623456789012"
          style="border: 0px;"></iframe>
        <!-- 添加导航按钮 -->
        <a href="https://www.google.com/maps/dir//DR+MOTOR+LTD,+Kwun+Tong+Promenade,+Kwun+Tong,+Hong+Kong" target="_blank" class="navigate-button">{{ t('startNavigation') }}</a>
      </div>
    </div>
    
    <div class="social-media-section">
      <h3>{{ t('followUs') }}</h3>
      <div class="social-media-icons">
        <a href="https://www.facebook.com/profile.php?id=61577205355724" target="_blank" class="social-icon" :title="t('facebook')">
          <img src="../assets/facebook.png" :alt="t('facebook')">
        </a>
        <a href="whatsapp://send?phone=+85266860815" target="_blank" class="social-icon" :title="t('whatsapp')">
          <img src="../assets/whatsapp.png" :alt="t('whatsapp')">
        </a>
        <a href="https://www.instagram.com/dr_moto_ev_hk_ltd/" target="_blank" class="social-icon" :title="t('instagram')">
          <img src="../assets/Instagram.png" :alt="t('instagram')">
        </a>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'ContactPage',
  setup() {
    const { t } = useI18n();
    return { t };
  }
});
</script>

<style scoped>
.contact-page {
  width: 100%;
  min-height: 100vh;
  padding: 40px 20px;
  box-sizing: border-box;
  background-color: #f9f9f9;
}

.contact-header {
  text-align: center;
  margin-bottom: 40px;
}

.contact-header h1 {
  font-size: 32px;
  color: #12aa4a;
  margin-bottom: 10px;
}

.contact-header p {
  font-size: 16px;
  color: #666;
}

.contact-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  gap: 40px;
  margin-bottom: 40px;
  height: 400px; /* 设置统一高度 */
}

.contact-info {
  flex: 1;
  background-color: white;
  padding: 30px;
  border-radius: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  gap: 20px; /* 使用固定间距确保一致的垂直布局 */
  height: 100%; /* 占满父容器高度 */
  overflow: visible; /* 确保内容不会被裁剪 */
}

.contact-item {
  display: flex;
  align-items: flex-start;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
  min-height: 60px; /* 确保每个项目有足够的高度 */
}

.contact-item:last-child {
  border-bottom: none;
  min-height: 80px; /* 为地址项设置更大的最小高度 */
}

.contact-icon {
  font-size: 24px;
  margin-right: 20px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #e8f5e9;
  border-radius: 50%;
  color: #12aa4a;
  flex-shrink: 0;
}

.contact-details {
  flex: 1;
  min-width: 0; /* 确保内容不会溢出容器 */
}

.contact-details h3 {
  font-size: 18px;
  margin-bottom: 8px;
  color: #333;
  margin-top: 0;
}

.contact-details p {
  font-size: 16px;
  color: #666;
  line-height: 1.6;
  margin: 0;
  word-wrap: break-word; /* 确保长文本可以自动换行 */
  width: 100%; /* 确保文本占据完整宽度 */
}

.contact-map {
  flex: 1;
  background-color: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  position: relative;
  height: 100%; /* 占满父容器高度 */
}

.contact-map iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.navigate-button {
  position: absolute;
  bottom: 20px;
  right: 20px;
  background-color: #12aa4a;
  color: white;
  padding: 10px 20px;
  border-radius: 20px;
  text-decoration: none;
  font-size: 16px;
  font-weight: bold;
  transition: all 0.3s ease;
  z-index: 10;
}

.navigate-button:hover {
  background-color: #0e8e3e;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.social-media-section {
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
  padding: 30px;
  background-color: white;
  border-radius: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.social-media-section h3 {
  font-size: 20px;
  margin-bottom: 20px;
  color: #333;
}

.social-media-icons {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.social-icon {
  display: inline-block;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
  background-color: #f0f0f0;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.social-icon:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.social-icon img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .contact-container {
    flex-direction: column;
    gap: 20px;
    height: auto;
  }
  
  .contact-info, .contact-map {
    height: auto;
  }
  
  .contact-map {
    min-height: 300px;
  }
  
  .contact-header h1 {
    font-size: 28px;
  }
  
  .contact-item {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .contact-icon {
    margin-bottom: 10px;
  }
  
  .social-media-icons {
    gap: 15px;
  }
  
  .social-icon {
    width: 45px;
    height: 45px;
  }
  
  .navigate-button {
    font-size: 14px;
    padding: 8px 16px;
    bottom: 15px;
    right: 15px;
  }
}

@media (max-width: 480px) {
  .contact-page {
    padding: 20px 15px;
  }
  
  .contact-header h1 {
    font-size: 24px;
  }
  
  .contact-info {
    padding: 20px;
  }
}
</style>
